import { batch } from 'react-redux';
import template from 'url-template';
import { setBobLoading } from './bobActions';
import { get, has, isEmpty, uniqBy } from 'lodash';

import moment from 'moment';

import {
    ANIMATE_SERVICE_CALL_LIST,
    FETCH_APPOINTMENT_STATUSES,
    FETCH_CALL_PRIORITIES,
    FETCH_CALL_STATUSES,
    FETCH_COMPANY_ALIAS,
    FETCH_ISSUE_TYPES,
    FETCH_SERVICE_ITEM_LIST,
    FETCH_SM_AREAS,
    FETCH_SM_CLIENTS,
    FETCH_SM_CONTACTS,
    FETCH_SM_EQUIPMENT_AND_SYSTEMS,
    FETCH_SM_RULES,
    FETCH_SM_SITES,
    FETCH_SM_TECHNICIAN_LIST,
    RESET_FILTERS,
    RESET_LISTS,
    SET_ACTIVE_APPOINTMENT,
    SET_ACTIVE_ITEM,
    SET_ARE_FILTERS_APPLIED,
    SET_CALL_ISSUES,
    SET_CALL_SOURCES_FILTER,
    SET_CALL_STATUS,
    SET_CALL_STATUSES_FILTER,
    SET_CLIENTS_FILTER,
    SET_END_TIMESTAMP,
    SET_EQUIPMENT_FILTER,
    SET_DRAWER_OPEN,
    SET_ISSUE_TYPES_FILTER,
    SET_ITEM_IS_ACTIVE,
    SET_PRIORITY,
    SET_PRIORITIES_FILTER,
    SET_SEARCH_VALUE,
    SET_SITES_FILTER,
    SET_SM_AREA,
    SET_SM_CLIENT,
    SET_SM_CONTACT,
    SET_SM_EQUIPMENT_OR_SYSTEM,
    SET_SM_SITE,
    SET_SORTBY_FILTER,
    SET_START_TIMESTAMP,
    SET_SYSTEMS_FILTER
} from '../actions/actionTypes';

import { handleNetworkError, enqueueSnackbar } from './applicationMessageActions';
import { fetchClientContacts, fetchSiteContacts } from './contactActions';
import { setProgressBarLoading } from './coreActions';

import awsHeader from '../helpers/awsAuth';
import k2aBaseApi from '../apis/key2act';
import lambdaBaseApi from '../apis/lambda';

import { callPriorities } from '../data/callPriorities';
import axios from 'axios';
import { ConcurrencyManager } from 'axios-concurrency';

const DEFAULT_PAGE_LIMIT = 100;
const DEFAULT_SORT = 'name asc';
const MAX_CONCURRENCY_REQUESTS = 10;

const AreasUrl = template.parse('/sites/{siteId}/areas{?searchFilter,limit}');
const AliasUrl = template.parse('/servicecalls-email-config');
const AppointmentsUrl = template.parse('/serviceappointments{?serviceCallId,pageSize,page,notify}');
const AppointmentUrl = template.parse('/serviceappointments/{id}');
const AppointmentStatusesUrl = template.parse('/serviceappointments/statuses');
const CompaniesUrl = template.parse('/companies/{companyId}/clients{?limit,page}');
const ContactsUrl = template.parse('/clients/{clientId}/contacts{?limit}');
const EquipmentUrl = template.parse('/sites/{siteId}/equipment{?limit}');
const IssueTypesUrl = template.parse('/issuetypes');
const NotifyAppointmentUrl = template.parse('/serviceappointments/{id}/notify');
const NotifyServiceCallUrl = template.parse('/servicecalls/{id}/notify');
const RulesUrl = template.parse('/rules{?orderby,page,pageSize}');
const RuleListUrl = template.parse('rules/rules-find{?name,orderby,page,pageSize,isCountQuery}');
const ServiceCallsUrl = template.parse('/servicecalls{?notify,loadRelations,pageSize,page,orderby,searchFilter,insertTimestamp[lte],insertTimestamp[gte],clientId[in],businessType[in],siteId[in],buildingType[in],systemType[in],equipmentType[in],issueTypes[allin],priority[in],statusId[in],source[in]}');
const ServiceCallUrl = template.parse('/servicecalls/{id}{?forcedelete}');
const SitesUrl = template.parse('/clients/{clientId}/sites{?limit}');
const StatusesUrl = template.parse('/servicecalls/statuses');
const SystemsUrl = template.parse('/sites/{siteId}/systems{?limit}');
const TechniciansUrl = template.parse('/servicetechnicians{?technicianId,pageSize,page}');

export const serviceManagementActionRouter = (entity, entityId, entityPayload, action, parentId, options = {}) => async (dispatch, getState) => {
    let check1, check2;

    switch (action) {
        case 'Create':
            dispatch(setIsAnimated(entityId));

            switch (entity) {
                case 'ServiceCalls':
                    check1 = await dispatch(areFiltersEmpty());
                    check2 = await dispatch(isDateInRange(entityPayload));

                    if (check1 && check2) {
                        dispatch(insertServiceCall(entityPayload));
                    }

                    break;
                case 'ServiceAppointments':
                    dispatch(insertAppointment(entityId, entityPayload, parentId, action));
                    break;
                default:
                    break;
            }
            break;
        case 'Delete':
            switch (entity) {
                case 'ServiceCalls':
                    dispatch(removeServiceCall(entityId));
                    break;
                case 'ServiceAppointments':
                    dispatch(removeAppointment(entityId, parentId));
                    break;
                default:
                    break;
            }
            break;
        case 'Update':
            dispatch(setIsAnimated(entityId));

            switch (entity) {
                case 'ServiceCalls':
                    dispatch(updateServiceCall(entityId, entityPayload));

                    break;
                case 'ServiceAppointments':
                    dispatch(insertAppointment(entityId, entityPayload, parentId, action));
                    break;
                default:
                    break;
            }
            break;
        default:
            break;
    }
};

export const areFiltersEmpty = () => async (dispatch, getState) => {
    const searchValue = getState().svcManagement.searchValue;
    const clientIds = getState().svcManagement.clientsFilter.clients.map(client => client.id);
    const businessTypeIds = getState().svcManagement.clientsFilter.businessTypes.map(type => type.id);
    const siteIds = getState().svcManagement.sitesFilter.sites.map(site => site.id);
    const buildingTypeIds = getState().svcManagement.sitesFilter.buildingTypes.map(type => type.id);
    const systemTypeIds = getState().svcManagement.systemsFilter.systems.map(system => system.id);
    const equipmentTypeIds = getState().svcManagement.equipmentFilter.equipment.map(equipment => equipment.id);
    const issueTypes = getState().svcManagement.issueTypesFilter.issueTypes.map(issueType => issueType.id);
    const priorities = getState().svcManagement.prioritiesFilter.priorities.map(priority => priority.name);
    const statusIds = getState().svcManagement.callStatusesFilter.callStatuses.map(status => status.id);
    const sources = getState().svcManagement.callSourcesFilter.callSources.map(source => source.name);

    return isEmpty(searchValue) &&
           isEmpty(clientIds) &&
           isEmpty(businessTypeIds) &&
           isEmpty(siteIds) &&
           isEmpty(buildingTypeIds) &&
           isEmpty(systemTypeIds) &&
           isEmpty(equipmentTypeIds) &&
           isEmpty(issueTypes) &&
           isEmpty(priorities) &&
           isEmpty(statusIds) &&
           isEmpty(sources);
};

export const isDateInRange = entity => async (dispatch, getState) => {
    const sortByFilter = getState().svcManagement.sortByFilter;
    const startTimeStamp = getState().svcManagement.startTimeStamp.toISOString();
    const endTimeStamp = getState().svcManagement.endTimeStamp.toISOString();

    const insertTimestamp = moment(get(entity, 'insertTimestamp'));
    const lastModifiedTimestamp = moment(get(entity, 'lastModifiedTimestamp'));

    if (sortByFilter === 'insertTimestamp') {
        return (insertTimestamp.isBefore(endTimeStamp) && insertTimestamp.isAfter(startTimeStamp)) ||
               (insertTimestamp.isSame(endTimeStamp) || insertTimestamp.isSame(startTimeStamp));
    }

    return (lastModifiedTimestamp.isBefore(endTimeStamp) && lastModifiedTimestamp.isAfter(startTimeStamp)) ||
           (lastModifiedTimestamp.isSame(endTimeStamp) || lastModifiedTimestamp.isSame(startTimeStamp));
};

export const createAlias = (alias, options = {}) => async dispatch => {
    const header = await awsHeader();

    const body = {
        enabled: true,
        alias
    };

    try {
        await lambdaBaseApi.post(
            AliasUrl.expand({
                ...options
            }),
            body,
            header
        );

        await dispatch(fetchAlias());
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const createAppointment = (body, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    try {
        await lambdaBaseApi.post(
            AppointmentsUrl.expand({
                ...options
            }),
            body,
            header
        );

        return true;
    } catch (error) {
        dispatch(handleNetworkError(error));

        return false;
    }
};

export const deleteAppointment = (id, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    try {
        dispatch(setProgressBarLoading(true));

        await lambdaBaseApi.delete(
            AppointmentUrl.expand({
                id,
                ...options
            }),
            header
        );

        return true;
    } catch (error) {
        dispatch(handleNetworkError(error));

        return false;
    }
};

export const deleteServiceCall = (id, options = {}) => async dispatch => {
    const header = await awsHeader();

    options.forcedelete || (options.forcedelete = 'true');

    try {
        dispatch(setProgressBarLoading(true));

        await lambdaBaseApi.delete(
            ServiceCallUrl.expand({
                id,
                ...options
            }),
            header
        );

        return true;
    } catch (error) {
        dispatch(handleNetworkError(error));

        return false;
    }
};

export const fetchAlias = (options = {}) => async dispatch => {
    const header = await awsHeader();

    try {
        const response = await lambdaBaseApi.get(
            AliasUrl.expand({
                ...options
            }),
            header
        );

        const rawPayload = get(response, 'data.data[0]', {});
        let payload;

        if (!isEmpty(rawPayload)) {
            payload = {
                enabled: rawPayload.enabled,
                email:   rawPayload.aliasEmail,
                id:      rawPayload.id,
                name:    rawPayload.alias,
            };
        } else {
            payload = {
                email:   '',
                enabled: false,
                id:      '',
                name:    ''
            };
        }

        dispatch({
            type: FETCH_COMPANY_ALIAS,
            payload
        });

    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const fetchAppointment = (serviceCallId, options = {}) => async dispatch => {
    const header = await awsHeader();

    options.pageSize || (options.pageSize = DEFAULT_PAGE_LIMIT);

    try {
        const response = await lambdaBaseApi.get(
            AppointmentsUrl.expand({
                serviceCallId,
                ...options
            }),
            header
        );

        const payload = get(response, 'data.data', []);

        return payload;
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const fetchAppointments = (serviceCallId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    try {
        const activeItem = getState().svcManagement.activeItem;
        const appointmentStatuses = getState().svcManagement.appointmentStatuses;
        const technicians = getState().svcManagement.technicianList;

        let appointments = [];

        const getPayload = async (page = 1) => {
            options.pageSize = DEFAULT_PAGE_LIMIT;
            options.page = page;

            const response = await lambdaBaseApi.get(
                AppointmentsUrl.expand({
                    serviceCallId,
                    ...options
                }),
                header
            );

            const payload = get(response, 'data.data', []);
            const totalCount = get(response, 'data.meta.totalCount', 0);

            payload.forEach(appointment => {
                if (technicians.length && technicians[0].items.length) {
                    const technician = technicians[0].items.find(tech => tech.id === appointment.primaryTechnicianId);

                    if (technician) {
                        appointment.primaryTechnicianName = technician.name;
                    } else {
                        appointment.primaryTechnicianName = '';
                    }
                } else {
                    appointment.primaryTechnicianName = '';
                }

                if (appointmentStatuses.length && appointmentStatuses[0].items.length) {
                    const status = appointmentStatuses[0].items.find(status => status.id === appointment.statusId);

                    if (status) {
                        appointment.status = status.label;
                    }
                }
            });

            appointments = [...appointments, ...payload];

            page++;

            if (payload.length > 0 && appointments.length < totalCount) {
                return await getPayload(page);
            }

            return;
        };

        await getPayload();

        activeItem.appointments = [...appointments];

        await dispatch(setItemActive(activeItem));
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const fetchAppointmentStatuses = (options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    try {
        const response = await lambdaBaseApi.get(
            AppointmentStatusesUrl.expand({
                ...options
            }),
            header
        );

        const payload = get(response, 'data.data', []);

        payload.forEach(status => status.name = status.label);

        const processedPayload = [
            {
                items:     payload.sort(_sorter),
                name:      'Appointment Statuses',
                itemProps: {
                    type: 'appointmentStatuses'
                }
            }
        ];

        dispatch({
            type:    FETCH_APPOINTMENT_STATUSES,
            payload: processedPayload
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const fetchCallPriorities = () => async dispatch => {
    dispatch({
        type:    FETCH_CALL_PRIORITIES,
        payload: callPriorities
    });
};

export const fetchInitialAreas = (siteId, options = {}) => async dispatch => {
    const header = await awsHeader();

    options.limit || (options.limit = DEFAULT_PAGE_LIMIT);

    try {
        const response = await k2aBaseApi.get(
            AreasUrl.expand({
                siteId,
                ...options
            }),
            header
        );

        const areasPayload = get(response, 'data.data', []);

        const payload = [
            {
                items:     [...areasPayload].sort(_sorter),
                name:      'Areas',
                itemProps: {
                    type: 'areas'
                }
            }
        ];

        dispatch({
            type: FETCH_SM_AREAS,
            payload
        });

    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const fetchInitialSMClients = (companyId, options = {}) => async dispatch => {
    const header = await awsHeader();

    options.limit || (options.limit = DEFAULT_PAGE_LIMIT);

    try {
        const response = await k2aBaseApi.get(
            CompaniesUrl.expand({
                companyId,
                ...options
            }),
            header
        );

        const clientsPayload = get(response, 'data.data', []);

        const payload = [
            {
                items:     [...clientsPayload].sort(_sorter),
                name:      'Clients',
                itemProps: {
                    type: 'clients'
                }
            }
        ];

        dispatch({
            type: FETCH_SM_CLIENTS,
            payload
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const fetchInitialContacts = (clientId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    options.limit || (options.limit = DEFAULT_PAGE_LIMIT);

    try {
        const response = await k2aBaseApi.get(
            ContactsUrl.expand({
                clientId,
                ...options
            }),
            header
        );
        const contactsPayload = get(response, 'data.data', []);

        const payload = [
            {
                items:     [...contactsPayload].sort(_sorter),
                name:      'Contacts',
                itemProps: {
                    type: 'contacts'
                }
            }
        ];

        dispatch({
            type: FETCH_SM_CONTACTS,
            payload
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const fetchInitialEquipmentAndSystems = (siteId, options = {}) => async dispatch => {
    const header = await awsHeader();

    options.limit || (options.limit = DEFAULT_PAGE_LIMIT);

    try {
        const equipmentResponse = await k2aBaseApi.get(
            EquipmentUrl.expand({
                siteId,
                ...options
            }),
            header
        );

        const systemResponse = await k2aBaseApi.get(
            SystemsUrl.expand({
                siteId,
                ...options
            }),
            header
        );

        const equipmentPayload = get(equipmentResponse, 'data.data', []);
        const systemPayload = get(systemResponse, 'data.data', []);

        const payload = [
            {
                items:     [...equipmentPayload].sort(_sorter),
                name:      'Equipment',
                itemProps: {
                    type: 'equipment'
                }
            },
            {
                items:     [...systemPayload].sort(_sorter),
                name:      'Systems',
                itemProps: {
                    type: 'systems'
                }
            }
        ];

        dispatch({
            type: FETCH_SM_EQUIPMENT_AND_SYSTEMS,
            payload
        });

    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const fetchInitialSites = (clientId, options = {}) => async dispatch => {
    const header = await awsHeader();

    options.limit || (options.limit = DEFAULT_PAGE_LIMIT);

    try {
        const result = await k2aBaseApi.get(
            SitesUrl.expand({
                clientId,
                ...options
            }),
            header
        );

        const sitesPayload = get(result, 'data.data', []);

        const payload = [
            {
                items:     [...sitesPayload].sort(_sorter),
                name:      'Sites',
                itemProps: {
                    type: 'sites'
                }
            }
        ];

        dispatch({
            type: FETCH_SM_SITES,
            payload
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const fetchIssueTypes = (options = {}) => async dispatch => {
    const header = await awsHeader();

    try {
        const response = await lambdaBaseApi.get(
            IssueTypesUrl.expand({
                ...options
            }),
            header
        );

        const payload = get(response, 'data.data', []);

        payload.forEach(issue => {
            issue.name = issue.label;

            if (issue.label === 'healthAndSafety') issue.name = 'Health and Safety';
        });

        dispatch({
            type: FETCH_ISSUE_TYPES,
            payload
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const fetchServiceItemList = (options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    const serviceItemList = getState().svcManagement.serviceItemList;

    dispatch(setProgressBarLoading(true));

    if (serviceItemList.length) {
        dispatch({
            type:    FETCH_SERVICE_ITEM_LIST,
            payload: []
        });
    }
    const searchValue = getState().svcManagement.searchValue;
    const sortByFilter = getState().svcManagement.sortByFilter;
    const startTimeStamp = getState().svcManagement.startTimeStamp.toISOString();
    const endTimeStamp = getState().svcManagement.endTimeStamp.toISOString();
    const clientIds = getState().svcManagement.clientsFilter.clients.map(client => client.id);
    const businessTypeIds = getState().svcManagement.clientsFilter.businessTypes.map(type => type.id);
    const siteIds = getState().svcManagement.sitesFilter.sites.map(site => site.id);
    const buildingTypeIds = getState().svcManagement.sitesFilter.buildingTypes.map(type => type.id);
    const systemTypeIds = getState().svcManagement.systemsFilter.systems.map(system => system.id);
    const equipmentTypeIds = getState().svcManagement.equipmentFilter.equipment.map(equipment => equipment.id);
    const issueTypes = getState().svcManagement.issueTypesFilter.issueTypes.map(issueType => issueType.id);
    const priorities = getState().svcManagement.prioritiesFilter.priorities.map(priority => priority.name);
    const statusIds = getState().svcManagement.callStatusesFilter.callStatuses.map(status => status.id);
    const sources = getState().svcManagement.callSourcesFilter.callSources.map(source => source.name);

    options.loadRelations || (options.loadRelations = true);
    options.orderby || (options.orderby = `${sortByFilter} desc`);
    options['insertTimestamp[gte]'] || (options['insertTimestamp[gte]'] = startTimeStamp);
    options['insertTimestamp[lte]'] || (options['insertTimestamp[lte]'] = endTimeStamp);

    if (searchValue.length) options.searchFilter = searchValue;
    if (priorities.length) options['priority[in]'] = priorities.join(', ');
    if (sources.length) options['source[in]'] = sources.join(', ');
    if (clientIds.length) options['clientId[in]'] = clientIds.join(', ');
    if (businessTypeIds.length) options['businessType[in]'] = businessTypeIds.join(', ');
    if (siteIds.length) options['siteId[in]'] = siteIds.join(', ');
    if (buildingTypeIds.length) options['buildingType[in]'] = buildingTypeIds.join(', ');
    if (systemTypeIds.length) options['systemType[in]'] = systemTypeIds.join(', ');
    if (equipmentTypeIds.length) options['equipmentType[in]'] = equipmentTypeIds.join(', ');
    if (issueTypes.length) options['issueTypes[allin]'] = issueTypes.join(', ');
    if (statusIds.length) options['statusId[in]'] = statusIds.join(', ');

    try {
        options.pageSize = options.pageSize || DEFAULT_PAGE_LIMIT; //DEFAULT_PAGE_LIMIT;
        options.page = options.page || 1;

        dispatch(setBobLoading('FetchServiceCallLists'));
        const response = await lambdaBaseApi.get(
            ServiceCallsUrl.expand({
                ...options
            }),
            header
        );
        const meta = get(response, 'data.meta');
        let payload = get(response, 'data.data');
        const payloadMeta = {meta, serviceItemList: _processServiceCalls(payload,sortByFilter)};

        if (isEmpty(payload)) {
            await dispatch(resetActiveItem());
        }

        dispatch({
            type:    FETCH_SERVICE_ITEM_LIST,
            payload: payloadMeta
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    } finally {
        dispatch(setBobLoading('FetchServiceCallLists'));
        dispatch(setProgressBarLoading(false));
    }
};

export const fetchSMRules = (companyId, options = {}, sort) => async (dispatch, getState) => {
    const header = await awsHeader();

    const rulesList = getState().svcManagement.rulesList;
    const body = {
        clients:    [],
        sites:      [],
        equipments: []
    };

    if (rulesList.length) {
        dispatch({
            type:    FETCH_SM_RULES,
            payload: []
        });
    }

    header.headers['K2A-Company'] = companyId;

    options.pageSize || (options.pageSize = 20);
    options.page || (options.page = 1);
    options.searchFilter || (options.searchFilter = '');
    options.orderby = sort || (options.orderby = DEFAULT_SORT);
    options.id = companyId;

    try {
        const manager = ConcurrencyManager(lambdaBaseApi, MAX_CONCURRENCY_REQUESTS);
        options.isCountQuery = true;
        const response = await lambdaBaseApi.post(
            RuleListUrl.expand({
                ...options
            }),
            body,
            header
        );

        const data = get(response, 'data.data', []) || [];
        const meta = get(response, 'data.meta', {});
        const total = meta.totalCount;


        let totalPages = total / options.pageSize;
        let count;
        if (Number.isInteger(totalPages)) {
            count = totalPages;
        } else {
            count = totalPages + 1;
        }

        // fetching all rules as a background process
        let promises = [];
        for (let i = 1; i <= count; i++) {
            options.page = i;
            options.isCountQuery = false;
            promises.push(
                lambdaBaseApi.post(
                    RuleListUrl.expand({
                        ...options
                    }),
                    body,
                    header
                )
            );
        }

        let results = [];

        await Promise.all(promises.map(p => p))
            .then(axios.spread((...result) => {
                result.forEach(r => {
                    results.push(r.data.data);
                });
            }));

        manager.detach();

        let allRules = data.concat(...results);

        dispatch({
            type:    FETCH_SM_RULES,
            payload: allRules
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const fetchStatuses = (options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    try {
        const response = await lambdaBaseApi.get(
            StatusesUrl.expand({
                ...options
            }),
            header
        );

        const payload = get(response, 'data.data', []);
        payload.forEach(status => status.name = status.label);

        const processedPayload = [
            {
                items:     payload.sort(_sorter),
                name:      'Call Statuses',
                itemProps: {
                    type: 'callStatuses'
                }
            }
        ];

        dispatch({
            type:    FETCH_CALL_STATUSES,
            payload: processedPayload
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const fetchTechniciansList = (options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    dispatch({
        type:    FETCH_SM_TECHNICIAN_LIST,
        payload: []
    });

    try {
        const getPayload = async (page = 1) => {
            options.pageSize = DEFAULT_PAGE_LIMIT;
            options.page = page;

            const response = await lambdaBaseApi.get(
                TechniciansUrl.expand({
                    ...options
                }),
                header
            );

            const totalCount = get(response, 'data.meta.totalCount', 0);
            const rawPayload = get(response, 'data.data', []);

            rawPayload.forEach(tech => tech.name = `${tech.firstName} ${tech.lastName}`);

            const rawPriorItems = getState().svcManagement.technicianList;
            const priorItems = get(rawPriorItems[0], 'items', []);

            const payload = [
                {
                    items:     [...priorItems, ...rawPayload],
                    name:      'Technicians',
                    itemProps: {
                        type: 'technicians'
                    }
                }
            ];

            dispatch({
                type: FETCH_SM_TECHNICIAN_LIST,
                payload
            });

            page++;

            if (payload.length > 0 && payload[0].items.length < totalCount) {
                return await getPayload(page);
            }

            return;
        };

        await getPayload();
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const insertAppointment = (id, payload, parentId, action) => async (dispatch, getState) => {
    const serviceItemList = getState().svcManagement.serviceItemList;
    const activeItem = getState().svcManagement.activeItem;
    const appointmentStatuses = getState().svcManagement.appointmentStatuses;
    const technicians = getState().svcManagement.technicianList;

    if (action === 'Create') {
        if (has(serviceItemList[0], 'events')) {
            serviceItemList.forEach(item => {
                item.events.forEach(event => {
                    if (event.id === parentId) {
                        event.appointmentCount = event.appointmentCount + 1;
                    }
                });
            });
        } else {
            serviceItemList.forEach(item => {
                if (item.id === parentId) {
                    item.appointmentCount = item.appointmentCount + 1;
                }
            });
        }

        dispatch({
            type:    FETCH_SERVICE_ITEM_LIST,
            payload: serviceItemList
        });
    }

    if (isEmpty(activeItem) || activeItem.id !== parentId) {
        return;
    }

    if (activeItem.appointments && activeItem.appointments.length) {
        const existingAppointment = activeItem.appointments.find(appointment => appointment.id === id);

        if (existingAppointment) {
            activeItem.appointments.forEach((appointment, index) => {
                if (appointment.id === id) {
                    activeItem.appointments[index] = {...appointment, ...payload};

                    activeItem.appointmentCount = activeItem.appointmentCount + 1;
                }
            });

            dispatch(setItemActive(activeItem));

            dispatch(enqueueSnackbar('Appointment updated successfully.', 'success'));

            return;
        }
    }

    if (technicians.length && technicians[0].items.length) {
        const technician = technicians[0].items.find(tech => tech.id === payload.primaryTechnicianId);

        if (technician) {
            payload.primaryTechnicianName = technician.name;
        } else {
            payload.primaryTechnicianName = '';
        }
    } else {
        payload.primaryTechnicianName = '';
    }

    if (appointmentStatuses.length && appointmentStatuses[0].items.length) {
        const status = appointmentStatuses[0].items.find(status => status.id === payload.statusId);

        if (status) {
            payload.status = status.label;
        }
    }

    if (activeItem.appointments) {
        activeItem.appointments = [payload, ...activeItem.appointments];

        activeItem.appointmentCount = activeItem.appointmentCount + 1;
    } else {
        activeItem.appointments = [payload];

        activeItem.appointmentCount = 1;
    }

    dispatch(setItemActive(activeItem));

    dispatch(enqueueSnackbar('Appointment created successfully.', 'success'));
};

export const insertServiceCall = entityPayload => async (dispatch, getState) => {
    const serviceItemList = getState().svcManagement.serviceItemList;

    if (has(serviceItemList[0], 'events')) {
        serviceItemList[0].events.unshift(entityPayload);
    } else {
        serviceItemList.unshift(entityPayload);
    }

    dispatch({
        type:    FETCH_SERVICE_ITEM_LIST,
        payload: serviceItemList
    });
};

export const removeAppointment = (id, parentId) => async (dispatch, getState) => {
    const serviceItemList = getState().svcManagement.serviceItemList;
    const activeItem = getState().svcManagement.activeItem;

    if (has(serviceItemList[0], 'events')) {
        serviceItemList.forEach(item => {
            item.events.forEach(event => {
                if (event.id === parentId) {
                    if (event.appointmentCount > 0) event.appointmentCount = event.appointmentCount - 1;
                }
            });
        });
    } else {
        serviceItemList.forEach(item => {
            if (item.id === parentId) {
                if (item.appointmentCount > 0) item.appointmentCount = item.appointmentCount - 1;
            }
        });
    }

    dispatch({
        type:    FETCH_SERVICE_ITEM_LIST,
        payload: serviceItemList
    });

    if (isEmpty(activeItem) || activeItem.id !== parentId) {
        dispatch(setProgressBarLoading(false));

        return;
    }

    activeItem.appointments = activeItem.appointments.filter(appointment => appointment.id !== id);
    if (activeItem.appointmentCount > 0) activeItem.appointmentCount = activeItem.appointmentCount - 1;

    dispatch(setItemActive(activeItem));

    dispatch(setProgressBarLoading(false));

    dispatch(enqueueSnackbar('Appointment deleted successfully.', 'success'));
};

export const removeServiceCall = id => async (dispatch, getState) => {
    const serviceItemList = getState().svcManagement.serviceItemList;
    const activeItem = getState().svcManagement.activeItem;
    const currentApp = getState().core.currentApp;

    if (activeItem.id === id) {
        dispatch(resetActiveItem());
    }

    if (has(serviceItemList[0], 'events')) {
        serviceItemList.forEach(item => {
            item.events = [...item.events.filter(event => event.id !== id)];
        });

        dispatch({
            type:    FETCH_SERVICE_ITEM_LIST,
            payload: serviceItemList
        });
    } else {
        const updatedServiceItemList = serviceItemList.filter(item => item.id !== id);

        dispatch({
            type:    FETCH_SERVICE_ITEM_LIST,
            payload: updatedServiceItemList
        });
    }

    dispatch(setProgressBarLoading(false));

    if (currentApp === 'servicemanagement') {
        dispatch(enqueueSnackbar('Service request deleted successfully.', 'success'));
    }
};

export const resetActiveCall = () => async (dispatch, getState) => {
    const activeItem = getState().svcManagement.activeItem;

    const companyId = get(activeItem, 'relatedCompany.id', '');
    const clientId = get(activeItem, 'relatedClient.id', '');
    const siteId = get(activeItem, 'relatedSite.id', '');
    const areaId = get(activeItem, 'relatedArea.id', '');

    const equipmentId = activeItem.relatedEquipment ? activeItem.relatedEquipment.id : null;
    const systemId = activeItem.relatedSystem ? activeItem.relatedSystem.id : null;

    const dispatches = [];

    if (clientId) {
        dispatches.push(dispatch(fetchInitialSites(clientId)));
        if (process.env.contactsEnabled) {
            dispatches.push(dispatch(fetchClientContacts(clientId)));
        } else {
            dispatches.push(dispatch(fetchInitialContacts(clientId)));
        }
    }

    if (companyId) {
        dispatches.push(dispatch(fetchInitialSMClients(companyId)));
    }

    if (siteId) {
        dispatches.push(dispatch(fetchInitialEquipmentAndSystems(siteId)));
        dispatches.push(dispatch(fetchInitialAreas(siteId)));
    }

    await Promise.all(dispatches.map(p => p.catch(err => err))).then(() => {
        batch(() => {
            dispatch(setCallStatus(activeItem.status));
            dispatch(setPriority(activeItem.priority));
            dispatch(setSMArea(areaId));
            dispatch(setSMClient(clientId));
            dispatch(setSMContact(activeItem.clientContactId));
            dispatch(setSMSite(siteId));
            dispatch(setCallIssues(activeItem.issueTypes));
        });

        if (equipmentId) {
            dispatch(setSMEquipmentOrSystem(equipmentId, 'equipment'));
        } else if (systemId) {
            dispatch(setSMEquipmentOrSystem(systemId, 'system'));
        }
    });

};

export const resetActiveItem = () => async dispatch => {
    await dispatch(setItemActive({}));

    dispatch({
        type:    SET_ITEM_IS_ACTIVE,
        payload: false
    });
};

export const resetContacts = () => async dispatch => {
    dispatch({
        type:    FETCH_SM_CONTACTS,
        payload: []
    });
};

export const resetFilters = () => async dispatch => {
    dispatch({
        type: RESET_FILTERS
    });
};

export const resetLists = () => async dispatch => {
    dispatch({
        type: RESET_LISTS
    });
};

export const resetSites = () => async dispatch => {
    dispatch({
        type:    FETCH_SM_SITES,
        payload: []
    });
};

export const saveActiveCall = (options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    const svcManagement = getState().svcManagement;
    const companyInfo = getState().companyInfo;
    const body = {};

    body.companyId = get(companyInfo, 'companyId', null);
    body.id = get(svcManagement, 'activeItem.id', null);
    body.priority = get(svcManagement, 'priority', null);
    body.clientId = get(svcManagement, 'targetClient.id', null);
    body.siteId = get(svcManagement, 'targetSite.id', null);
    body.areaId = get(svcManagement, 'targetArea.id', null);
    body.issueTypes = [...svcManagement.callIssues];
    body.summary = get(svcManagement, 'activeItem.summary', null);
    body.description = get(svcManagement, 'activeItem.description', null);
    body.requesterEmail = get(svcManagement, 'activeItem.requesterEmail', null);
    body.requesterName = get(svcManagement, 'activeItem.requesterName', null);
    body.requesterPhone = get(svcManagement, 'activeItem.requesterPhone', null);
    body.statusId = _getCallStatusId(get(svcManagement, 'callStatus', ''), svcManagement.callStatuses);
    body.clientContactId = get(svcManagement, 'targetContact.id', null);

    if (svcManagement.targetEquipmentOrSystem.equipmentType) {
        body.equipmentId = get(svcManagement, 'targetEquipmentOrSystem.id', null);
    } else if (svcManagement.targetEquipmentOrSystem.systemType) {
        body.systemId = get(svcManagement, 'targetEquipmentOrSystem.id', null);
    }

    try {
        await lambdaBaseApi.put(
            ServiceCallsUrl.expand({
                ...options
            }),
            body,
            header
        );
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const sendAppointmentNotification = id => async dispatch => {
    const header = await awsHeader();

    try {
        await lambdaBaseApi.post(
            NotifyAppointmentUrl.expand({
                id
            }),
            {},
            header
        );

        dispatch(enqueueSnackbar('Communication sent to client.', 'success'));

    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const sendServiceCallNotification = id => async dispatch => {
    const header = await awsHeader();

    try {
        await lambdaBaseApi.post(
            NotifyServiceCallUrl.expand({
                id
            }),
            {},
            header
        );

        dispatch(enqueueSnackbar('Communication sent to client.', 'success'));

    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const setAppointmentActive = appointment => async dispatch => {
    dispatch({
        type:    SET_ACTIVE_APPOINTMENT,
        payload: appointment
    });
};

export const setAreFiltersApplied = toggleState => async dispatch => {
    dispatch({
        type:    SET_ARE_FILTERS_APPLIED,
        payload: toggleState
    });
};

export const setCallSourcesFilter = callSources => async dispatch => {
    dispatch({
        type:    SET_CALL_SOURCES_FILTER,
        payload: callSources
    });
};

export const setCallStatus = status => async dispatch => {
    dispatch({
        type:    SET_CALL_STATUS,
        payload: status
    });
};

export const setCallStatusesFilter = callStatuses => async dispatch => {
    dispatch({
        type:    SET_CALL_STATUSES_FILTER,
        payload: callStatuses
    });
};

export const setClientsFilter = clients => async dispatch => {
    dispatch({
        type:    SET_CLIENTS_FILTER,
        payload: clients
    });
};

export const setDrawerOpen = isOpen => async dispatch => {
    dispatch({
        type:    SET_DRAWER_OPEN,
        payload: isOpen
    });
};

export const setEnableEmailToServiceCall = payload => async (dispatch, getState) => {
    const alias = getState().svcManagement.alias;

    alias.enabled = payload;

    dispatch({
        type:    FETCH_COMPANY_ALIAS,
        payload: alias
    });
};

export const setEndTimestamp = timestamp => async dispatch => {
    dispatch({
        type:    SET_END_TIMESTAMP,
        payload: timestamp
    });
};

export const setEquipmentFilter = equipment => async dispatch => {
    dispatch({
        type:    SET_EQUIPMENT_FILTER,
        payload: equipment
    });
};

export const setCallIssues = callIssues => async dispatch => {
    dispatch({
        type:    SET_CALL_ISSUES,
        payload: callIssues
    });
};

export const setIsAnimated = payload => async dispatch => {
    dispatch({
        type: ANIMATE_SERVICE_CALL_LIST,
        payload
    });
};

export const setIssueTypesFilter = types => async dispatch => {
    dispatch({
        type:    SET_ISSUE_TYPES_FILTER,
        payload: types
    });
};

export const setItemActive = item => async (dispatch, getState) => {
    const { relatedCompany, relatedClient, relatedSite } = item;

    const relatedClientId = get(relatedClient, 'id', '');
    const relatedCompanyId = get(relatedCompany, 'id', '');
    const relatedSiteId = get(relatedSite, 'id', '');

    const dispatches = [];

    if (relatedClientId) {
        dispatches.push(dispatch(fetchInitialSites(relatedClientId)));

        if (process.env.contactsEnabled) {
            dispatches.push(dispatch(fetchSiteContacts(relatedClientId, relatedSiteId)));
        } else {
            dispatches.push(dispatch(fetchInitialContacts(relatedClientId)));
        }
    }

    if (relatedCompanyId) {
        dispatches.push(dispatch(fetchInitialSMClients(relatedCompanyId)));
    }

    if (relatedSiteId) {
        dispatches.push(dispatch(fetchInitialEquipmentAndSystems(relatedSiteId)));
        dispatches.push(dispatch(fetchInitialAreas(relatedSiteId)));
    }

    await Promise.all(dispatches.map(p => p.catch(err => err))).then(() => {
        batch(() => {
            dispatch({
                type:    SET_ACTIVE_ITEM,
                payload: item
            });

            dispatch({
                type:    SET_ITEM_IS_ACTIVE,
                payload: true
            });
        });
    });
};

export const setPriority = priority => async dispatch => {
    dispatch({
        type:    SET_PRIORITY,
        payload: priority
    });
};

export const setPrioritiesFilter = priorities => async dispatch => {
    dispatch({
        type:    SET_PRIORITIES_FILTER,
        payload: priorities
    });
};

export const setSearchValue = searchValue => async dispatch => {
    dispatch({
        type:    SET_SEARCH_VALUE,
        payload: searchValue
    });
};

export const setSitesFilter = sites => async dispatch => {
    dispatch({
        type:    SET_SITES_FILTER,
        payload: sites
    });
};

export const setSMArea = areaId => async (dispatch, getState) => {
    if (isEmpty(areaId)) {
        dispatch({
            type:    SET_SM_AREA,
            payload: {}
        });

        return;
    }

    const areas = getState().svcManagement.areasList;
    const payload = areas[0].items.find(({ id }) => id === areaId);

    dispatch({
        type: SET_SM_AREA,
        payload
    });
};

export const setSMClient = clientId => async (dispatch, getState) => {
    if (isEmpty(clientId)) {
        dispatch({
            type:    SET_SM_CLIENT,
            payload: {}
        });

        return;
    }

    const clients = getState().svcManagement.clientsList;
    const payload = clients[0].items.find(({ id }) => id === clientId);

    dispatch({
        type: SET_SM_CLIENT,
        payload
    });
};

export const setSMContact = contactId => async (dispatch, getState) => {
    if (isEmpty(contactId)) {
        dispatch({
            type:    SET_SM_CONTACT,
            payload: {}
        });

        return;
    }

    const contacts = process.env.contactsEnabled ? getState().contact.siteContacts : getState().svcManagement.contactsList;
    const payload = process.env.contactsEnabled ? contacts.find(({ id }) => id === contactId) : contacts[0].items.find(({ id }) => id === contactId);

    dispatch({
        type: SET_SM_CONTACT,
        payload
    });
};

export const setSMEquipmentOrSystem = (targetId, flag) => async (dispatch, getState) => {
    if (isEmpty(targetId)) {
        dispatch({
            type:    SET_SM_EQUIPMENT_OR_SYSTEM,
            payload: {}
        });

        return;
    }

    const equipmentAndSystems = getState().svcManagement.equipmentAndSystemList;
    let equipment, systems, targetEquipment, targetSystem;

    switch (flag) {
        case 'equipment':
            equipment = equipmentAndSystems.find(({ name }) => name === 'Equipment');
            targetEquipment = equipment.items.find(({ id }) => id === targetId);

            dispatch({
                type:    SET_SM_EQUIPMENT_OR_SYSTEM,
                payload: targetEquipment
            });
            return;
        case 'system':
            systems = equipmentAndSystems.find(({ name }) => name === 'Systems');
            targetSystem = systems.items.find(({ id }) => id === targetId);

            dispatch({
                type:    SET_SM_EQUIPMENT_OR_SYSTEM,
                payload: targetSystem
            });
            return;
        default:
            break;
    }
};

export const updateActiveCall = (updates, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    const activeItem = getState().svcManagement.activeItem;
    const companyInfo = getState().companyInfo;

    const body = {
        companyId:       get(companyInfo, 'companyId', ''),
        workOrder:       get(activeItem, 'workOrder', ''),
        systemId:        get(activeItem, 'relatedSystem.id', null),
        requesterEmail:  get(activeItem, 'requesterEmail', ''),
        clientId:        get(activeItem, 'relatedClient.id', null),
        requesterPhone:  get(activeItem, 'requesterPhone', ''),
        clientContactId: get(activeItem, 'clientContactId', ''),
        source:          get(activeItem, 'source', ''),
        priority:        get(activeItem, 'priority', ''),
        equipmentId:     get(activeItem, 'relatedEquipment.id', null),
        issueTypes:      get(activeItem, 'issueTypes', []),
        areaId:          get(activeItem, 'relatedArea.id', null),
        statusId:        get(activeItem, 'statusId', ''),
        lockedBy:        get(activeItem, 'lockedBy', null),
        requesterName:   get(activeItem, 'requesterName', ''),
        siteId:          get(activeItem, 'relatedSite.id', ''),
        id:              get(activeItem, 'id', ''),
        ...updates
    };

    try {
        await lambdaBaseApi.put(
            ServiceCallsUrl.expand({
                ...options
            }),
            body,
            header
        );

        return true;
    } catch (error) {
        dispatch(handleNetworkError(error));

        return false;
    }
};

export const updateAppointment = (body, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    try {
        await lambdaBaseApi.put(
            AppointmentsUrl.expand({
                ...options
            }),
            body,
            header
        );

        return true;
    } catch (error) {
        dispatch(handleNetworkError(error));

        return false;
    }
};

export const updateEmailEnabled = (options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    const alias = getState().svcManagement.alias;

    const body = {
        enabled: alias.enabled,
        id:      alias.id
    };

    try {
        await lambdaBaseApi.patch(
            AliasUrl.expand({
                ...options
            }),
            body,
            header
        );
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const updateRuleEnabled = (id, isEnabled, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    const body = {
        faultServiceCallsEnabled: isEnabled,
        id
    };

    const rulesList = getState().svcManagement.rulesList;

    try {
        const response = await lambdaBaseApi.patch(
            RulesUrl.expand({
                ...options
            }),
            body,
            header
        );

        const payload = get(response, 'data.data', {});

        rulesList.forEach(rule => {
            if (rule.id === payload.id) {
                rule.faultServiceCallsEnabled = payload.faultServiceCallsEnabled;
            }
        });

        dispatch({
            type:    FETCH_SM_RULES,
            payload: rulesList
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const updateServiceCall = (id, payload) => async (dispatch, getState) => {
    const serviceItemList = getState().svcManagement.serviceItemList;
    const activeItem = getState().svcManagement.activeItem;

    if (has(serviceItemList[0], 'events')) {
        serviceItemList.forEach((item, itemIndex) => {
            item.events.forEach((event, eventIndex) => {
                if (event.id === id) {
                    item.events[eventIndex] = {...event, ...payload};
                }
            });
        });

        dispatch({
            type:    FETCH_SERVICE_ITEM_LIST,
            payload: serviceItemList
        });
    } else {
        const targetServiceItem = serviceItemList.find(item => item.id === id);
        const updatedServiceItemList = serviceItemList.filter(item => item.id !== id);
        const updatedServiceItem = {...targetServiceItem, ...payload};

        updatedServiceItemList.unshift(updatedServiceItem);

        dispatch({
            type:    FETCH_SERVICE_ITEM_LIST,
            payload: updatedServiceItemList
        });
    }

    if (activeItem.id === id) {
        const targetItem = {...activeItem, ...payload};

        dispatch(setItemActive(targetItem));
    }
};

export const setSMSite = siteId => async (dispatch, getState) => {
    if (isEmpty(siteId)) {
        dispatch({
            type:    SET_SM_SITE,
            payload: {}
        });

        return;
    }

    const sites = getState().svcManagement.sitesList;
    const payload = sites[0].items.find(({ id }) => id === siteId);

    dispatch({
        type: SET_SM_SITE,
        payload
    });
};

export const setSortbyFilter = filterState => async dispatch => {
    dispatch({
        type:    SET_SORTBY_FILTER,
        payload: filterState
    });
};

export const setStartTimestamp = timestamp => async dispatch => {
    dispatch({
        type:    SET_START_TIMESTAMP,
        payload: timestamp
    });
};

export const setSystemsFilter = systems => async dispatch => {
    dispatch({
        type:    SET_SYSTEMS_FILTER,
        payload: systems
    });
};

const _getCallStatusId = (status, statuses) => {
    if (isEmpty(status)) return null;

    const targetStatus = statuses[0].items.find(item => item.name === status);

    return get(targetStatus, 'id', null);
};

const _processServiceCalls = (rawServiceCalls, sortByFilter) => {
    if (isEmpty(rawServiceCalls)) return [];

    const serviceCalls = uniqBy(rawServiceCalls, 'id');

    if (sortByFilter === 'insertTimestamp') {
        const utc = moment.utc();
        const timeZone = moment.tz.guess();

        const today = moment.tz(utc, timeZone).format().split('T')[0];
        const yesterday = moment.tz(utc, timeZone).subtract(1, 'days').format().split('T')[0];

        const extractDate = (date, timeZone) => {
            return moment.tz(date, timeZone).format().split('T')[0];
        };

        const callStructure = [
            {
                date:   'Today',
                events: []
            },
            {
                date:   'Yesterday',
                events: []
            }
        ];

        serviceCalls.forEach(call => {
            const insertDate = extractDate(call.insertTimestamp, timeZone);

            if (insertDate === today) {
                callStructure[0].events.push(call);
            } else if (insertDate === yesterday) {
                callStructure[1].events.push(call);
            } else {
                const targetBucket = callStructure.find(bucket => bucket.date === insertDate);

                if (targetBucket) {
                    targetBucket.events.push(call);
                } else {
                    callStructure.push({
                        'date':   insertDate,
                        'events': [call]
                    });
                }
            }
        });

        return callStructure;
    }

    return serviceCalls;
};

const _sorter = (a, b) => {
    let roleA = a.name.toUpperCase();
    let roleB = b.name.toUpperCase();

    if (roleA < roleB) {
        return -1;
    }
    if (roleA > roleB) {
        return 1;
    }

    return 0;
};
